/**
 * Argentine peso.
 */
export var ARS = {
  code: 'ARS',
  base: 10,
  exponent: 2
};